// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { QueryResultValueResponse } from './query-result-value-response';

/** See com.rev360.pms.api.controller.query.QueryResultResponse */
/* istanbul ignore next */
@GandalfModel
export class QueryResultResponse extends GandalfModelBase {

	@GandalfArray(QueryResultValueResponse)
	values!: QueryResultValueResponse[];

}
